module.exports = __webpack_public_path__ + "band_6.bd18459e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/male_to_female/band_6.png
// module id = /uAs
// module chunks = 0